<template>
  <v-flex xs12 sm8 md4 lg4>
    <v-form>
      <v-card class="elevation-4 pa-3">
        <v-card-text>
          <div class="layout column align-center">
            <img
              src="@/assets/logo-120x120.png"
              :alt="sistem.app_title"
              height="120"
            />
            <h1
              class="my-3 display-1 font-weight-regular"
              :class="`${sistem.app_theme}--text`"
            >
              {{ sistem.app_title }}
            </h1>
          </div>
          <v-text-field
            append-icon="person"
            autofocus
            type="text"
            v-model="form.username"
            v-validate="'required'"
            name="username"
            data-vv-name="username"
            label="Username"
            data-vv-as="Username"
            :error-messages="errors.collect('username')"
          >
          </v-text-field>
          <v-text-field
            append-icon="lock"
            type="password"
            v-model="form.password"
            v-validate="'required'"
            name="password"
            data-vv-name="password"
            label="Password"
            data-vv-as="Password"
            :error-messages="errors.collect('password')"
          >
          </v-text-field>
          <v-switch
            v-model="rememberMe"
            label="Ingat saya"
            :color="sistem.app_theme"
            class="pa-0 ma-0"
          >
          </v-switch>
        </v-card-text>

        <v-card-actions>
          <public-menus></public-menus>
          <v-spacer></v-spacer>
          <v-btn
            :color="sistem.app_theme"
            dark
            type="submit"
            @click.prevent="submit"
            >Login
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</template>

<script>
import { mapState } from "vuex";
import PublicMenus from "@/components/public/PublicMenus";
import Util from "@/util";

export default {
  name: "login",
  components: {
    PublicMenus
  },
  data() {
    return {
      form: {
        username: Util.ls.get("username"),
        password: Util.ls.get("password")
      },
      rememberMe: !!Util.ls.get("username")
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("sistem", ["sistem"])
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store.dispatch("auth/LOGIN", this.form).then(() => {
            // rememberMe
            if (this.rememberMe) {
              Util.ls.set("username", this.form.username);
              Util.ls.set("password", this.form.password);
            } else {
              Util.ls.remove("username", this.form.username);
              Util.ls.remove("password", this.form.password);
            }
            // redirect to the last page
            let redirect = "/dashboard";
            if (this.$route.query.redirect)
              redirect = this.$route.query.redirect;
            this.$router.push(redirect);
          });
        }
      });
    }
  }
};
</script>
